import { AxiosError } from 'axios';

export const handleError = (error: unknown, prefix: string = ''): string => {
  let message = '';
  if (error instanceof AxiosError) {
    message = error.response?.data || 'Unknown Axios error';
  } else if (error instanceof Error) {
    message = error.message;
  } else {
    message = 'Unknown error';
  }

  if (prefix.length > 0) {
    message = `${prefix}: ${message}`;
  }

  console.error(message);

  return message;
};
